import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationComponent } from './pagination.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
    declarations: [PaginationComponent],
    imports: [CommonModule, IconModule],
    exports: [PaginationComponent],
})
export class PaginationModule { }